/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React, { useState } from "react"
import { IRecord } from "../../types/schema"
import { useAsyncEffect } from "../../hooks/useAsyncEffect"
import { Fields, Form2 } from "@cd2/forms"

type IProductGroups = IRecord<"leads", "name" | "company_name">

export function LeadsSelect({
  label,
  value,
  onChange,
  disabled,
  error,
  required,
  branchId,
  isClearable,
  postFieldText,
}: {
  label?: string
  value?: string
  onChange(id: string, lead: IProductGroups): void
  disabled?: boolean
  error?: string
  required?: boolean
  isClearable?: boolean
  branchId?: string
  postFieldText?: React.ReactNode
}) {
  const skeem = window.skeem

  const [leads, setLeads] = useState<IProductGroups[]>([])

  function handleChange(id: string) {
    console.log(id)
    onChange(id, leads.find(w => w.id === id)!)
  }

  useAsyncEffect(async () => {
    const leads = await skeem.fetch2<IProductGroups[]>({
      model: {
        name: "leads",
        attributes: ["name", "company_name"],
        sort: { by: "name", direction: "asc" },
      },
    })
    setLeads(leads)
  }, [branchId])

  if (leads.length === 0) {
    return <div>Loading</div>
  }

  const accountRefCss = css`
    font-size: 12px;
    font-weight: 600;
    color: #999;
  `

  return (
    <Fields.Select2
      label={
        <Form2.FieldLabel
          fieldName="lead"
          label={label || "Lead"}
          required={required}
          errored={!!error}
        />
      }
      options={leads}
      onChange={value => handleChange(value?.id)}
      value={leads.find(v => v.id === value)}
      getOptionLabel={opt => opt.company_name}
      getOptionValue={opt => opt.id}
      disabled={disabled}
      error={error}
      isClearable={isClearable}
      postFieldText={postFieldText}
      components={{
        SingleValue: props => {
          const { innerProps, getStyles } = props
          const lead = props.data

          return (
            <div
              {...innerProps}
              style={{
                ...getStyles("singleValue", props),
              }}
            >
              <div>{lead?.company_name}</div>
              <div css={accountRefCss}>{lead?.name}</div>
            </div>
          )
        },
        Option: props => {
          const { innerProps, innerRef, getStyles } = props
          const lead = props.data as IProductGroups

          return (
            <div
              ref={innerRef}
              {...innerProps}
              style={{
                ...getStyles("option", props),
              }}
            >
              <div>{lead?.company_name}</div>
              <div css={accountRefCss}>{lead?.name}</div>
            </div>
          )
        },
      }}
    />
  )
}
